/**
 * Bearer token helper for Cognitory API calls.
 * Lives outside auth/ and components/ so token APIs stay out of panel source.
 */

import { getCognitoryAuth } from "../firebase/firebaseApp";

export async function resolveCognitoryBearerToken(): Promise<string | null> {
  const auth = getCognitoryAuth();
  await auth.authStateReady();
  const user = auth.currentUser;
  if (!user || user.isAnonymous) {
    return null;
  }
  try {
    const token = await user.getIdToken();
    return typeof token === "string" && token.length > 0 ? token : null;
  } catch {
    return null;
  }
}
